import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayDate,
  DisplayGuid
} from '../items';
import { DetailsRightBar, NoLink, Divider } from './DetailsRightBar';

class ExternalActivityInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      externalActivityData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { externalActivityId } } } = this.props;
    const { api: { externalActivities: { getExternalActivity } } } = this.props;

    try {
      const externalActivityData = await getExternalActivity(externalActivityId);
      this.setState({ externalActivityData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { externalActivityId } } } = this.props;
    const { externalActivityData, errorMessage } = this.state;

    let mappedData = null;

    if (externalActivityData) {
      const {
        id,
        createdAt,
        hash,
        hashIngredients,
        integrationId,
        isBuried,
        crawlingId,
        title,
        startsAt,
        endsAt,
        duration,
        price,
        coach,
        externalReference,
        availableSpots,
        integratedResourceId
      } = externalActivityData;

      const durationInMinutes = (value) => {
        if (!value) return '';
        const parts = value.split(':').map((part) => parseInt(part, 10));
        if (parts.length !== 3 || parts.some(Number.isNaN)) {
          return value;
        }
        const [hours, minutes, seconds] = parts;
        const totalMinutes = (hours * 60) + minutes + Math.floor(seconds / 60);
        return totalMinutes.toString();
      };

      // Format External Reference if it's JSON
      const formatExternalReference = (ref) => {
        if (!ref) return '';
        try {
          const parsed = JSON.parse(ref);
          return <pre style={{
            background: '#f5f5f5',
            padding: '10px',
            borderRadius: '4px',
            fontSize: '12px',
            overflow: 'auto'
          }}>{JSON.stringify(parsed, null, 2)}</pre>;
        } catch (e) {
          return ref;
        }
      };

      // Integration Id link with filter
      const integrationLink = integrationId ? (
        <span className='display-guid'>
          <a href={`/integrations?integrationId=${integrationId}`}>
            {integrationId}
          </a>
        </span>
      ) : '';

      mappedData = {
        Id: <DisplayGuid>{id}</DisplayGuid>,
        'Created At': <DisplayDate>{createdAt}</DisplayDate>,
        Title: title || '',
        'Integration Id': integrationLink,
        'Crawling Id': crawlingId ?
          <DisplayGuid baseAnchor='/crawling'>{crawlingId}</DisplayGuid> :
          '',
        'Integrated Resource Id': integratedResourceId ? integratedResourceId :
          '',
        'Starts At': <DisplayDate>{startsAt}</DisplayDate>,
        'Ends At': <DisplayDate>{endsAt}</DisplayDate>,
        'Duration In Minutes': durationInMinutes(duration),
        Price: price !== null && price !== undefined ? `${price} DKK` : '',
        Coach: coach || '',
        'External Reference': formatExternalReference(externalReference),
        'Available Spots': availableSpots !== null && availableSpots !== undefined ? availableSpots : '',
        'Is Buried': isBuried.toString(),
        Hash: hash || '',
        'Hash Ingredients': hashIngredients || ''
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='External Activity details'
                documentDescription='External Activity details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                External Activity
              </h2>
              <h5 className='main-page-subheader'>{externalActivityId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>
              <NoLink>None</NoLink>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const ExternalActivity = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(ExternalActivityInternal)));

ExternalActivity.requiresLogin = true;
ExternalActivity.propTypes = { isLoggedIn: PropTypes.bool };

export default ExternalActivity;
